import {connect} from "react-redux"
import State from "../../../../models/State"

export const mapStateToProps = (state: State) => {
    const {template, text} = state

    return {
        text,
        templating: template,
    }
}

export default connect(mapStateToProps)
